/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Manage_Rename_FieldInputs */

const en_us2_coach_manage_rename_field = /** @type {(inputs: Coach_Manage_Rename_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation name`)
};

const pt_br2_coach_manage_rename_field = /** @type {(inputs: Coach_Manage_Rename_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome da conversa`)
};

const es_419_coach_manage_rename_field = /** @type {(inputs: Coach_Manage_Rename_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de la conversación`)
};

const pt_pt2_coach_manage_rename_field = /** @type {(inputs: Coach_Manage_Rename_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome da conversa`)
};

const fr_fr2_coach_manage_rename_field = /** @type {(inputs: Coach_Manage_Rename_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de la conversation`)
};

const de_de2_coach_manage_rename_field = /** @type {(inputs: Coach_Manage_Rename_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name der Unterhaltung`)
};

const it_it2_coach_manage_rename_field = /** @type {(inputs: Coach_Manage_Rename_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome della conversazione`)
};

/**
* | output |
* | --- |
* | "Conversation name" |
*
* @param {Coach_Manage_Rename_FieldInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_manage_rename_field = /** @type {((inputs?: Coach_Manage_Rename_FieldInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Manage_Rename_FieldInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_manage_rename_field(inputs)
	if (locale === "es-419") return es_419_coach_manage_rename_field(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_manage_rename_field(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_manage_rename_field(inputs)
	if (locale === "de-DE") return de_de2_coach_manage_rename_field(inputs)
	if (locale === "it-IT") return it_it2_coach_manage_rename_field(inputs)
	return en_us2_coach_manage_rename_field(inputs)
});
export { coach_manage_rename_field as "coach-manage.rename_field" }